// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  traceKey: __t.string().primaryKey().name("trace_key"),
  bountyId: __t.u64().name("bounty_id"),
  hunter: __t.identity(),
  found: __t.bool(),
  x: __t.f32(),
  z: __t.f32(),
  blurM: __t.f32().name("blur_m"),
  near: __t.string(),
  at: __t.timestamp(),
});
